jQuery(document).ready(function($){

	$('.jq-popup-pdf').magnificPopup({
		type: 'iframe',
		disableOn: 568,
		removalDelay: 205,
		mainClass: 'mfp--pdf'
	});

	$('.jq-popup-iframe').magnificPopup({
		type: 'iframe',
		disableOn: 568,
		removalDelay: 205,
		fixedContentPos: false,
		preloader: false,
		mainClass: 'mfp--pdf'
	});

	$('.jq-popup-img').magnificPopup({
		type: 'image',
		disableOn: 568,
		removalDelay: 205,
		mainClass: 'mfp--zoom',
		gallery: {
			enabled: true
		}
	});

	$('.jq-popup-text').magnificPopup({
		type: 'inline',
		removalDelay: 205,
		mainClass: 'mfp--text'
	});

	$('.jq-popup-form').magnificPopup({
		type: 'inline',
		removalDelay: 205,
		mainClass: 'mfp--form'
	});

});